import { render, staticRenderFns } from "./HeroVimeoVideo.vue?vue&type=template&id=1335543c&scoped=true&"
import script from "./HeroVimeoVideo.vue?vue&type=script&lang=js&"
export * from "./HeroVimeoVideo.vue?vue&type=script&lang=js&"
import style0 from "./HeroVimeoVideo.vue?vue&type=style&index=0&id=1335543c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1335543c",
  null
  
)

export default component.exports